// extracted by mini-css-extract-plugin
export default {"productDescription":"Rea-z","featuredDescription":"Sea-z","description":"Tea-z","more":"Uea-z","descriptionSku":"Vea-z"};